/**
 * 元数据相关api
 */
import axiosAPI from "@/components/request/request";

export default {
    // 获取元数据
    getAppMetadata(groupId) {
        return axiosAPI.get(`/app/metadata/tree/${groupId}`);
    },

    //获取项目分组树,self传true时知识产权只查询本人相关的
    getProjectTree(type, isSelf = false, onlyWithTask = false) {
        return axiosAPI.get(`/app/business/${type}/group/tree?self=${isSelf}&onlyWithTask=${onlyWithTask}`)
    },

    //获取个人工作任务列表
    getMyWorkTasks(projectId, isSelf = false) {
        return axiosAPI.post(`/app/bm/usertask/mytasks`, { businessId: projectId, self: isSelf });
    },

    getIprProjectTree() {
        return axiosAPI.get(`/app/business/group/ipr/tree`)
    },

    //计算请假时长
    calculateLeaveTime(params) {
        return axiosAPI.post(`/app/leave/calculate`, params);
    },

    //按照考勤时间计算时长
    calculateTimeSpan(params) {
        return axiosAPI.post(`/app/shift/calculate`, params);
    },

    //计算外出时长
    calculateOutingDays(params) {
        return axiosAPI.post(`/app/outing/calculate`, params);
    }
}